import axios from 'axios';

export function getPrinters() {
  return axios.get(`${process.env.VUE_APP_APIHOST}/gaa/printers`)
  .then(response => {
    // Insert QR code URL as well.
    if (!Array.isArray(response.data))
      throw new Error(`GET /printers failed somehow.`);
    response.data.forEach(printer => {
      printer['qrCodeUrl'] = `${process.env.VUE_APP_QRCODE_GENERATOR}`
        + `?size=150&margin=1&text=${process.env.VUE_APP_BIND_PRINTER_API}`
        + `?did=${printer['did']}&label=${printer['sn']}`;
      
      //FIXME: Show no shop name if shop_id is null (not bound).
      if (!printer['shop_id']) printer['shop_name'] = '';
    });
    return response;
  });
};

export function getPrinter(_printerId) {
  return axios.get(`${process.env.VUE_APP_APIHOST}/gaa/printers/${_printerId}`);
};

export function createPrinter(params) {
  return axios.post(`${process.env.VUE_APP_APIHOST}/gaa/printers`, params);
};

export function updatePrinter(_printerId, params) {
  return axios.put(`${process.env.VUE_APP_APIHOST}/gaa/printers/${_printerId}`, params);
};

export function deletePrinter(_printerId) {
  return axios.delete(`${process.env.VUE_APP_APIHOST}/gaa/printers/${_printerId}`);
};

export function purgePrinterQueue(_printerId) {
  return axios.delete(`${process.env.VUE_APP_APIHOST}/gaa/printers/${_printerId}/purge-queue`);
};

export function bindPrinter(_printerId, _shopId) {

};

export function unbindPrinter(_printerId, _shopId) {
  return axios.delete(`${process.env.VUE_APP_APIHOST}/gaa/printers/${_printerId}/unbind`, {
    headers: {},
    data: {
      "shopId": _shopId
    }
  });
};

export function setPrinterSound(_printerId, _sound) {
  axios.patch(
    `${process.env.VUE_APP_APIHOST}/gaa/printers/${_printerId}/volume`,
    {"command": _sound.volume}
  )
  .then(response => {})
  .catch(err => {console.error('printer-apis.js setPrinterSound error', err);});
  return axios.patch(
    `${process.env.VUE_APP_APIHOST}/gaa/printers/${_printerId}/voice`, 
    {"voiceId": _sound.type}
  );
};
